import React, { useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import {
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Input,
  FormGroup,
  Label,
  Button,
} from 'reactstrap';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';
import { AuthContext } from '../../context/authContext';
import { getItem, STORAGE_KEYS } from '../../services/storage';
import ModalClickable from '../modals/ModalClickable';
import ModalOptions from '../modals/ModalOptions';
import alumnosApiService from '../../services/http/alumnosApiService';
import facturasApiService from '../../services/http/facturasApiService';
import logger from '../../services/logger';

const ComponentCard = ({
  children,
  title,
  subtitle,
  dropdown,
  handleClick,
  name,
  isProfile,
  hasButtons,
}) => {
  const { userOU } = useContext(AuthContext);

  const userSession = getItem(STORAGE_KEYS.USER);
  const student = getItem(STORAGE_KEYS.STUDENT);
  const { empresaId, id } = useParams();

  const [loadingGoogleData, setLoadingGoogleData] = useState(false);
  const [googleData, setGoogleData] = useState(null);
  const [refreshGoogleData, setRefreshGoogleData] = useState(true);
  const [loadingActivation, setLoadingActivation] = useState(false);
  const [isModalShown, setIsModalShown] = useState(false);
  const [isModalShown2, setIsModalShown2] = useState(false);
  const [isModalShown3, setIsModalShown3] = useState(false);
  const [abono, setAbono] = useState(null);
  const [fechaAbono, setFechaAbono] = useState(null);
  const [importeAbonoData, setImporteAbonoData] = useState(null);

  // 🔸 Nuevo estado para el modal de abono
  const [modalAbono, setModalAbono] = useState(false);
  const [importeAbono, setImporteAbono] = useState(0);
  const [totalFactura, setTotalFactura] = useState(0);
  const [mensajeAbono, setMensajeAbono] = useState('');

  const stateAccount = useMemo(() => !googleData?.suspended, [googleData]);

  // --- Obtener datos de Google si es perfil de alumno ---
  useEffect(() => {
    const fetchStateAccount = async () => {
      setLoadingGoogleData(true);
      setRefreshGoogleData(false);

      try {
        const data = await alumnosApiService.recuperarGoogleDatosAlumno({
          headquarter: student.empresaId,
          studentId: student.id,
        });

        setGoogleData(data?.data);
      } catch {
        setGoogleData(null);
      } finally {
        setLoadingGoogleData(false);
      }
    };

    if (isProfile && refreshGoogleData) fetchStateAccount();
  }, [isProfile, refreshGoogleData, student?.empresaId, student?.id]);

  const fetchFactura = useCallback(async () => {
    try {
      const dataFactura = await facturasApiService.cargarDatosFactura({
        headquarter: empresaId,
        id,
      });
      const total = dataFactura?.facturacion?.total || 0;
      setTotalFactura(total);
      setImporteAbono(total);
      setAbono(dataFactura?.facturacion.nabono);
      setFechaAbono(dataFactura?.facturacion?.fabono);
      setImporteAbonoData(dataFactura?.facturacion?.importeAbono);
    } catch (err) {
      logger.error('Error al obtener el total de la factura:', err);
    }
  }, [empresaId, id]);

  // --- Obtener total de factura ---
  useEffect(() => {
    if (hasButtons) {
      fetchFactura();
    }
  }, [empresaId, fetchFactura, hasButtons, id]);

  // 🔹 Mover esta función fuera del useEffect

  // --- Acciones de botones existentes ---
  const handleActivationAccount = useCallback(async () => {
    setLoadingActivation(true);

    try {
      await alumnosApiService.activationAccount({
        headquarter: student.empresaId,
        idAlumno: student.id,
        isActive: !stateAccount,
      });

      setIsModalShown2(true);
    } catch (error) {
      logger.error(error);
    } finally {
      setRefreshGoogleData(true);
      setLoadingActivation(false);
      setIsModalShown(false);
    }
  }, [student, stateAccount]);

  const handleEmail = async () => {
    setIsModalShown3(true);
    try {
      await facturasApiService.crearFacturaPDF({
        headquarter: empresaId,
        id,
        email: true,
        emailName: userSession.profileObj.email,
      });
    } catch (error) {
      logger.error('Error al generar el PDF:', error);
    }
  };

  const handleExport = async () => {
    try {
      const response = await facturasApiService.crearFacturaPDF({
        headquarter: empresaId,
        id,
        email: false,
      });

      if (response && typeof response === 'object' && !Array.isArray(response)) {
        const byteArray = Object.values(response);
        const uint8Array = new Uint8Array(byteArray);
        const blob = new Blob([uint8Array], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      } else {
        throw new Error('La respuesta no contiene los bytes del PDF.');
      }
    } catch (error) {
      logger.error('Error al generar el PDF:', error);
    }
  };

  const handleCrearAbono = async () => {
    try {
      await facturasApiService.crearAbono({
        headquarter: empresaId,
        importeAbono,
        nFactura: id,
      });

      setMensajeAbono('Abono creado correctamente.');

      // 🔸 Volver a cargar los datos de la factura
      await fetchFactura();

      // 🔸 Cerrar modal después de un pequeño retraso
      setTimeout(() => {
        setModalAbono(false);
        setMensajeAbono('');
      }, 2000);
    } catch (error) {
      setMensajeAbono('Error al crear el abono. Inténtelo de nuevo.');
    }
  };
  return (
    <>
      {/* Modales auxiliares */}
      {isModalShown2 && <ModalClickable header="Actualizado correctamente." />}
      {isModalShown && (
        <ModalOptions
          header="¿Desea cambiar el estado de alumno en el campus?"
          load={setIsModalShown}
          text1="Cancelar"
          color1="danger"
          text2="Aceptar"
          color2="primary"
          onAccept={handleActivationAccount}
          withLoader={loadingActivation}
        />
      )}
      {isModalShown3 && <ModalClickable color="primary" header="Enviada correctamente." />}

      {/* 🔸 MODAL CREAR ABONO */}
      {modalAbono && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-4">
              <h5 className="mb-3">Crear Abono</h5>

              <Label className="form-label">Importe a abonar</Label>
              <Input
                type="number"
                max={totalFactura}
                value={importeAbono}
                onChange={(e) => {
                  const val = Number(e.target.value);
                  if (val <= totalFactura) {
                    setImporteAbono(val);
                  }
                }}
                className="mb-2"
              />

              {/* 🔹 Mensaje debajo del input */}
              {mensajeAbono && (
                <div
                  className={`mb-3 small ${
                    mensajeAbono.includes('Error') ? 'text-danger' : 'text-success'
                  }`}
                >
                  {mensajeAbono}
                </div>
              )}

              <div className="d-flex justify-content-end">
                <Button color="secondary" className="me-2" onClick={() => setModalAbono(false)}>
                  Cancelar
                </Button>
                <Button color="primary" onClick={handleCrearAbono}>
                  Crear
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tarjeta principal */}
      <Card color="white">
        <CardTitle tag="h4" className="border-bottom px-4 py-3 mb-0">
          <div className="d-flex justify-content-between align-items-center">
            {dropdown ? (
              <>
                {title}
                <Button onClick={handleClick}>Ir al listado</Button>
              </>
            ) : (
              <>{title}</>
            )}
            {name && <span className="ms-3">{name}</span>}

            {/* 🔸 Botones de acción */}
            {hasButtons && (
              <>
                <Button size="sm" onClick={handleExport}>
                  <Icon.FileText /> Exportar PDF
                </Button>
                {abono !== 'No abonada' ? (
                  <span>
                    Número abono: {abono}
                    {fechaAbono ? ` · Fecha: ${fechaAbono}` : ''}
                    {importeAbonoData != null ? ` · Importe: ${importeAbonoData} €` : ''}
                  </span>
                ) : (
                  <Button size="sm" onClick={() => setModalAbono(true)}>
                    <Icon.Tag /> Crear Abono
                  </Button>
                )}

                <Button size="sm" onClick={handleEmail} className="ms-2">
                  <Icon.Mail /> Enviar factura
                </Button>
              </>
            )}

            {/* Switch de perfil (sin cambios) */}
            {isProfile && !loadingGoogleData && !!googleData && (
              <FormGroup
                switch
                className="d-flex flex-row align-items-center justify-content-center gap-3 p-0"
              >
                <Label check htmlFor="active-account-switch" className="cursor-pointer">
                  {stateAccount ? 'Desactivar cuenta' : 'Activar cuenta'}
                </Label>
                <Input
                  type="switch"
                  name="active-account-switch"
                  id="active-account-switch"
                  checked={stateAccount}
                  onChange={() => {
                    setIsModalShown(true);
                    setIsModalShown2(false);
                  }}
                  style={{
                    backgroundColor: stateAccount ? '#53e17a' : '',
                    outline: 'none',
                    margin: 0,
                    cursor: 'pointer',
                  }}
                  disabled={
                    userOU.centro !== 'SUPERADMIN' &&
                    userSession.profileObj.email !== 'nfeneux@cedetecgroup.com' &&
                    userSession.profileObj.email !== 'asanjose@cedetecgroup.com'
                  }
                />
              </FormGroup>
            )}
          </div>
        </CardTitle>

        <CardBody className="p-4">
          <CardSubtitle className="text-muted mb-3">{subtitle || ''}</CardSubtitle>
          <div>{children}</div>
        </CardBody>
      </Card>
    </>
  );
};

ComponentCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.node,
  dropdown: PropTypes.bool,
  handleClick: PropTypes.func,
  name: PropTypes.string,
  isProfile: PropTypes.bool,
  hasButtons: PropTypes.bool,
};

export default ComponentCard;
